import { isModuleGranted, isSystemRole } from "./roleAccessUtils";

/** Separation-of-duties / high-impact heuristics for a role's screen access. */
export function roleRisks(role, catalog, access) {
  if (!role || !catalog) return [];
  const out = [];
  const pay = catalog.find((m) => m.key === "payroll");
  const people = catalog.find((m) => m.key === "employee");
  const payAcc = access?.payroll;
  const peopleAcc = access?.employee;

  if (pay && payAcc) {
    let canEdit = false;
    let canApprove = false;
    for (const s of pay.screens || []) {
      const row = payAcc.screens?.[s.key];
      if (row?.edit || row?.create) canEdit = true;
      if (row?.approve) canApprove = true;
    }
    if (canEdit && canApprove) {
      out.push(
        "Same role can change payroll data and approve / finalise it. This does not block save — only a soft warning. To clear it: untick Approve on Finalise (and any other Approve cells), or untick Edit / Create on process steps. Prefer preparer and approver on different roles."
      );
    }
  }

  if (people && peopleAcc && !isSystemRole(role)) {
    const canDeletePeople = (people.screens || []).some(
      (s) => peopleAcc.screens?.[s.key]?.delete === true
    );
    if (canDeletePeople) out.push("Can delete people records.");
  }

  return out;
}

export function modulesGrantedCount(catalog, access) {
  return (catalog || []).filter((m) => isModuleGranted(m, access?.[m.key])).length;
}
